// extracted by mini-css-extract-plugin
export var cancelButton = "_mq-5";
export var content = "_mq-3";
export var createButton = "_mq-6";
export var drawerContainer = "_mq-0";
export var footer = "_mq-2";
export var header = "_mq-1";
export var orderFormColumn = "_mq-4";